import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import WorkingUnitMappingGrid from '../../components/Budget/WorkingUnitMappingGrid';

const BudgetWorkingUnitMapping = () => {
    const { t } = useTranslation('budget');

    return (
        <>
            <Typography variant="subtitle1" fontWeight="bold">
                <span>{t('workingUnits.title')}</span>
            </Typography>
            <WorkingUnitMappingGrid />
        </>
    );
};

export default BudgetWorkingUnitMapping;
